import * as R from 'ramda'
import {
  dataWappCheckForUpdate,
  dataWappGetById,
  dataWappSearch,
} from '@weblite/action/wapp'
import { Wapp } from '@weblite/ts-action/wapp'
import { WappInput } from '@weblite-wapps/protocol'
import { bundleWappsVersion } from '$logic/wapps/wapps.helper'
import {
  WappsConfig,
  wappsConfigStorage,
  wappStorage,
} from '$logic/wapps/storage'
import { createWisInServer } from '$logic/wises'
import { postApi } from '$setup/http'
import { wsReq } from '$setup/ws'

export async function getWapp(id: string) {
  return wappStorage.get(id)
}

export const syncWapps = async () => {
  const wapps = await wappStorage.getAll()
  if (!wapps.length) return

  const { payload } = await wsReq(
    dataWappCheckForUpdate({
      wapps: bundleWappsVersion(wapps),
      alpha: getWappsConfig().alpha,
    }),
  )
  await wappStorage.insert(payload.wapps)
}

export async function getWappFromServer(id: string) {
  const res = await postApi(
    dataWappGetById({ id, alpha: getWappsConfig().alpha }),
  )
  return res?.payload?.wapp as Wapp
}

export async function getWappsFromServer(wapps: Record<string, number | null>) {
  return Promise.all(R.keys(wapps).map(getWappFromServer))
}

export async function searchWapps(searchQuery: string) {
  const res = await wsReq(
    dataWappSearch({ query: searchQuery, alpha: getWappsConfig().alpha }),
  )
  return res?.payload?.wapps
}

export const instantiateWapp = async (
  wappId: string,
  input?: WappInput,
): Promise<string> => {
  const { id: wisId } = await createWisInServer(wappId, input)
  return wisId
}

export function getWappsConfig(): WappsConfig {
  return (
    wappsConfigStorage.get() || {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      alpha: JSON.parse(import.meta.env.VITE_WAPP_ALPHA_ENABLE),
    }
  )
}

export async function setWappsConfig(config: Partial<WappsConfig>) {
  await wappsConfigStorage.set(config)
}
